module.exports = __webpack_public_path__ + "img/bank-js2.40fbd42b.png";